import React, { FC } from 'react'
import { FieldMetaProps } from 'formik'

import FormError from 'components/FormError'

export interface Props {
  meta: FieldMetaProps<unknown>
  id?: string
}

const FormFieldError: FC<Props> = ({ meta, id }) => {
  return meta.touched && meta.error ? (
    <div aria-live="assertive" aria-atomic="true" id={id}>
      <FormError name="error" errors={{ error: meta.error }} />
    </div>
  ) : null
}

export default FormFieldError
